var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"module-wrap"},[_c('div',{staticClass:"footer-common-line"}),_c('a',{staticClass:"footer-common",attrs:{"href":"tel: 010-63052088"}},[_vm._v(" 服务热线： 010-63052088 ")]),_c('p',{staticClass:"footer-common-pd24 footer-common-f12 footer-common-copyright",staticStyle:{"font-size":"13px"}},[_vm._v("Copyright2023 北京华卫通科健康科技有限公司版权所有")])])])
}]

export { render, staticRenderFns }